import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { GuidUtils } from "~app/common/utils/guid-utils";
import { canEdit } from "~app/role-permissions";
import { Atgard } from "../../models/atgard-models";
import { TradslagDTO } from "../../models/mbf-models";
import { AtgardSkogsvardTradslag } from "../../models/skogsvard/skogsvard-models";
import { AtgardMediatorService } from "../../services/atgard-mediator.service";
import { KontraktMediatorService } from "../../services/kontrakt-mediator.service";
import { SkogsvardForyngringService } from "../../services/skogsvard-foryngring.service";
import { SkogsvardService } from "../../services/skogsvard.service";
import { VirkeskopValidationService } from "../../services/validation/virkeskop-validation.service";
import { VirkeskopValidationMessageComponent } from "../../validation/validation-message/virkeskop-validation-message.component";
import { SkogsvardForyngringTradslagComponent } from "./skogsvard-foryngring-tradslag/skogsvard-foryngring-tradslag.component";
@Component({
    selector: "rask-skogsvard-foryngring",
    templateUrl: "./skogsvard-foryngring.component.html",
    styleUrls: ["./skogsvard-foryngring.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        VirkeskopValidationMessageComponent,
        SkogsvardForyngringTradslagComponent,
        ActionButtonComponent
    ]
})
export class SkogsvardForyngringComponent implements OnInit, OnDestroy {
    protected allatradslag: TradslagDTO[];
    protected kontraktReadonly = false;
    protected skogsvardTradslagLista: AtgardSkogsvardTradslag[] = [];
    protected skogsvardsAtgard: Atgard;

    private readonly atgardMediatorService = inject(AtgardMediatorService);
    private readonly kontraktMediatorService = inject(KontraktMediatorService);
    private readonly ngDestroyed$ = new Subject<void>();
    private readonly skogsvardForyngringService = inject(SkogsvardForyngringService);
    private readonly skogsvardService = inject(SkogsvardService);
    private readonly virkeskopValidationService = inject(VirkeskopValidationService);
    private readonly canEdit = canEdit();
    private get kontrakt() {
        return this.kontraktMediatorService.kontrakt;
    }

    ngOnDestroy(): void {
        this.ngDestroyed$.next();
        this.ngDestroyed$.complete();
    }

    ngOnInit(): void {
        this.atgardMediatorService.atgard$
            .subscribe(atgard => this.skogsvardsAtgard = atgard);

        this.skogsvardForyngringService.skogsvardForyngringTradslag$
            .subscribe(tradslag => {
                this.skogsvardTradslagLista = tradslag;
            });

        this.skogsvardService.getTradslag()
            .subscribe({
                next: (tradslag) => {
                    this.allatradslag = tradslag;
                },
                error: (e) => {
                    this.allatradslag = [];
                }
            });

        this.kontraktMediatorService.isReadonly$
            .pipe(
                map(readonly => readonly || !this.canEdit()),
                takeUntil(this.ngDestroyed$))
            .subscribe(readonly => this.kontraktReadonly = readonly);
    }

    protected addRow() {
        if (this.kontraktReadonly) {
            return;
        }
        const model = {
            tradslagId: null,
            frogiva: 0,
            guid: GuidUtils.newGuid(),
            arealandel: 100
        } as AtgardSkogsvardTradslag;

        this.skogsvardTradslagLista.push(model);
        this.skogsvardForyngringService.updateSkogsvardTradslag(model);
    }

    protected deleted(tradslag: AtgardSkogsvardTradslag) {
        const delCandidate = this.skogsvardTradslagLista.indexOf(tradslag);
        this.skogsvardTradslagLista.splice(delCandidate, 1);
        this.skogsvardForyngringService.deleteSkogsvardTradslag(tradslag.guid);
    }
}
